import { GetWishListApiParameter, getWishList } from "@NA/Services/ADIWishListService";
import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import { createHandlerChainRunner, Handler, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { CustomApiHandler, CustomHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import { getCatalogPageByPath } from "@insite/client-framework/Services/CategoryService";

interface Parameter {
    path: string;
}

type HandlerType = CustomApiHandler<Parameter, any & HasOnSuccess>;

export const DispatchBeginLoadL1Category: HandlerType = props => {
    props.dispatch({
        type: "Custom/L1Category/BeginLoading",
        result: true,
    });
};

export const LoadL1Category: HandlerType = async props => {
    props.apiResult = await getCatalogPageByPath({ path: "/catalog/deals/adi-choice" });
};

export const DispatchCompleteLoadL1Category: HandlerType = props => {
    if (props.apiResult) {
        setTimeout(() => {
            props.dispatch({
                type: "Custom/L1Category/CompleteLoading",
                result: false,
            });
        }, 1000);
    }
};

export const chain = [DispatchBeginLoadL1Category, LoadL1Category, DispatchCompleteLoadL1Category];
const loadL1CategoryData = createHandlerChainRunner(chain, "LoadL1CategoryData");
export default loadL1CategoryData;
